import styled from 'styled-components';

export const StripDiv = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
	gap: .5rem;
`;
export const LabelInfo = styled.div`
		font-size: 0.813rem;
		color: var(--subHeadingColor);
		transition-delay: 1s;
		font-family: Inter;
		font-weight:600;
		position:relative;
		border-right: 1px solid var(--borderLightColor);
		padding-right: .65rem;
		margin-right: 3.5px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		gap: .5rem;
		min-height:27px;

		// background:#fff;
		// padding: .55rem .85rem;
		// border-radius:25px;
	}
`;
export const GroundMountWrap = styled.div`
	padding-left: 0.25rem;
	padding-right: 0.25rem;
`;

export const GuideButton = styled.button<{ $active: boolean }>`
	display: inline-flex;
	align-items: center;
	height: 24px;
	padding: 0 0.375rem;
	margin: 0 0rem;
	border-radius: 9999px;
	outline: none;
	border: 1px solid ${({ $active }) => ($active ? 'var(--primary)' : 'var(--borderLightColor)')};
	background: ${({ $active }) => ($active ? 'var(--primary)' : 'var(--btnBadge)')};
	color: ${({ $active }) => ($active ? 'var(--btnLabel)' : 'var(--textTitleColor)')};
	font-size: 0.775rem;
	font-family: Inter, sans-serif;
	font-weight: 600;
	cursor: pointer;
	white-space: nowrap;
	transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;

	&:hover {
		border-color: ${({ $active }) => ($active ? 'var(--primary)' : 'var(--primary)')};
		background: ${({ $active }) => ($active ? 'var(--primary)' : 'var(--controlActiveBgColor)')};
		color: ${({ $active }) => ($active ? 'var(--btnLabel)' : 'var(--primary)')};
	}
	 
	/* &.snapactive {
		border-color: #2563eb;
		background: #fdfdfd;
		color: #2563eb;
	} */

`;
export const ButtonsWrap = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 2px;
	margin-left: 6px;
	margin-right: 6px;

	span {
		color: #efefef;
	}
`;
